import { IController } from 'angular';
import * as _ from 'lodash';

import { RegentsExam } from '../../../../../../../../ng2/shared/constants/regents.constant';
import { IRegentsExam } from '../../../../../../../../ng2/shared/constants/regents.constant';
import {
  IRegentsBulkPatch,
  IStudentToExamData,
  WizardUtils,
} from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

interface IStudentRecRatCourseData {
  _id: string;
  studentId: string;
  recommendedRegentsBasedOnCulminatingCourseRationle: string[]; // examNames[ ]
}

export class CulminatingCourseCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public filteredStudents; // modified students
  public studentRecRationalCulmCourseData: IStudentRecRatCourseData[];
  public regentsRecRationalsByExamName: IStudentToExamData;
  public totalExamsWithRecRationalCourse: number;
  public studentIdsWithRecRationalCourse: string[];
  public patches: IRegentsBulkPatch[];
  public languageHelper;
  public options: IWizardFilterActionsOptions;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.studentRecRationalCulmCourseData = this.getStudentRegentsRecRationalesDataCulmCourse();
    this.regentsRecRationalsByExamName = this.organizeRegentsRecRationalDataByExamName();
    this.studentIdsWithRecRationalCourse = this.getStudentIdsWithRegentsRecRationalCourse();
    this.totalExamsWithRecRationalCourse = this.WizardUtils.getCountOfStudentsToBePatched(
      this.regentsRecRationalsByExamName,
    );
    this.patches = this.WizardUtils.getRegentsExamBulkPatch(this.regentsRecRationalsByExamName, 'humanName');
    this.languageHelper = this.WizardUtils.getRegentsWizardLanguageHelper('humanName');

    this.options = {
      columnKeys: [
        'recommendedRegentsBasedOnCulminatingCourseRationle',
        'regentsSchedForNextAdmin',
        'currentCourseCodes',
      ],
    };
  }

  private getStudentRegentsRecRationalesDataCulmCourse(): IStudentRecRatCourseData[] {
    return _.map(this.filteredStudents, ({ _id, studentId, recommendedRegentsBasedOnCulminatingCourseRationle }) => ({
      _id,
      studentId,
      recommendedRegentsBasedOnCulminatingCourseRationle,
    }));
  }

  private organizeRegentsRecRationalDataByExamName(): IStudentToExamData {
    const baseObj = _.reduce(
      RegentsExam,
      (result: any, { humanName }: IRegentsExam) => {
        result[humanName] = { _ids: [], studentIds: [] };
        return result;
      },
      {},
    );
    _.each(this.studentRecRationalCulmCourseData, studentData => {
      const { _id, studentId, recommendedRegentsBasedOnCulminatingCourseRationle: recommendedRegents } = studentData;
      _.each(recommendedRegents, examName => {
        baseObj[examName]._ids.push(_id);
        baseObj[examName].studentIds.push(studentId);
      });
    });
    return baseObj;
  }

  private getStudentIdsWithRegentsRecRationalCourse(): string[] {
    return _.reduce(
      this.studentRecRationalCulmCourseData,
      (studentIdsArr, { recommendedRegentsBasedOnCulminatingCourseRationle, studentId }) => {
        if (recommendedRegentsBasedOnCulminatingCourseRationle.length >= 1) studentIdsArr.push(studentId);
        return studentIdsArr;
      },
      [],
    );
  }
}
